import React, { useState, useEffect } from 'react';

import screensaverPopup1 from '../../../../assets/images/screensaver/screesaver-1.png';
import screensaverPopup2 from '../../../../assets/images/screensaver/screesaver-2.png';
import screensaverPopup3 from '../../../../assets/images/screensaver/screesaver-3.png';
import screensaverPopup4 from '../../../../assets/images/screensaver/screesaver-4.png';
import { useLocation } from 'react-router-dom';
import { handleReset } from '../main-container/handleResetView';

const Screensaver = ({ inactivityTimeout = 30000, flipInterval = 3000, showPopup, long, lat, zoom, rotation, pitch, bearing, whereAmIBuilding, whereAmILevel, ciscoSpacesPopupImage, centerLong, centerLat, setShowAICard, setShowPopupCard, whereAmIScale = 150.091301692798277e-8, displayScreenSaver = true, setShowSearch}) => {
    const [isActive, setIsActive] = useState(true);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);


    const images = [
        ciscoSpacesPopupImage
        /**
        screensaverPopup1,
        screensaverPopup2,
        screensaverPopup3,
        screensaverPopup4, */
    ];

    let timeoutId;

    const resetTimeout = () => {
        //clearTimeout(timeoutId);
        setIsActive(false);
        // timeoutId = setTimeout(() => setIsActive(true), inactivityTimeout);
    };
    useEffect(() => {
        try {
            setIsActive(true);
            handleReset(
                long,
                lat,
                rotation ? rotation : -4.5,
                zoom ? zoom : 20,
                true, true, false, pitch, bearing, whereAmIBuilding, whereAmILevel, centerLong, centerLat, whereAmIScale
            )
        } finally {
            if (setShowAICard) {
                setShowAICard(false);
                setShowPopupCard(false);
            }
            setShowSearch(false);
            showPopup(null, null, false);
        }

    }, []);
    /** useEffect(() => {
         const handleUserActivity = () => resetTimeout();
 
         window.addEventListener('mousemove', handleUserActivity);
         window.addEventListener('keydown', handleUserActivity);
         window.addEventListener('click', handleUserActivity);
         window.addEventListener('touchstart', handleUserActivity);
 
         resetTimeout(); // Start the timer
 
         return () => {
             clearTimeout(timeoutId);
             window.removeEventListener('mousemove', handleUserActivity);
             window.removeEventListener('keydown', handleUserActivity);
             window.removeEventListener('click', handleUserActivity);
             window.removeEventListener('touchstart', handleUserActivity);
         };
     }, []); */

    useEffect(() => {
        if (isActive) {
            const flipIntervalId = setInterval(() => {
                setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
            }, flipInterval);

            return () => clearInterval(flipIntervalId);
        }
    }, [isActive, flipInterval]);

    return (
        isActive && (
            displayScreenSaver ? (
                <div className="screensaver-overlay" onClick={resetTimeout}>
                    <div className="screensaver-overlay-popup">
                        <img src={images[currentImageIndex]} alt="Screensaver Content" className="screensaver-overlay-image" />
                        <div className="cisco-spaces-popup-overlay-close" onClick={() => setIsActive(false)}>
                            <svg width="44" height="44" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_11306_4187)">
                                    <circle cx="22.5477" cy="22.1922" r="21.1342" stroke="white" stroke-width="0.98722" />
                                    <path d="M29.4141 26.9647L24.6432 22.1929L29.4141 17.4216L27.3198 15.3271L22.5486 20.0983L17.7775 15.3271L15.683 17.4216L20.4544 22.1929L15.6821 26.9647L17.7764 29.0589L22.5486 24.287L27.3198 29.0589L29.4141 26.9647Z" fill="white" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_11306_4187">
                                        <rect width="43.2556" height="43.2556" fill="white" transform="translate(0.919922 0.564453)" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                </div>
            ) : (resetTimeout(), null)
        )

    );
};

export default Screensaver;
